import { Reveal, Chapter } from "@/components/Reveal";
import { FLEET, IMAGES } from "@/data/content";

export const Fleet = () => (
  <section id="fleet" className="relative py-24 lg:py-32" data-testid="fleet-section">
    <div className="container-x">
      <Reveal>
        <Chapter index="06" label="The Fleet" />
        <div className="grid items-end gap-6 lg:grid-cols-[1.5fr_1fr]">
          <h2 className="font-display text-2xl font-bold tracking-tight text-offwhite sm:text-3xl lg:text-4xl">
            A Fleet Built to <span className="text-aqua">Stop Traffic on the Water</span>
          </h2>
          <p className="text-sm leading-relaxed text-muted lg:text-right">
            Fleet models, specifications and colors are subject to availability and change. Full technical
            specifications are shared with qualified applicants during onboarding.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-7 md:grid-cols-3">
        {FLEET.map((f, i) => (
          <Reveal key={f.name} delay={i * 0.1} className="h-full">
            <article className="card-line group flex h-full flex-col overflow-hidden rounded-2xl" data-testid={`fleet-card-${i}`}>
              <div className="relative overflow-hidden bg-white">
                <img
                  src={IMAGES[f.image]}
                  alt={`${f.name} Jet Car from the 2025 Watersports Car Series`}
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-aqua/40 via-transparent to-mint/30 mix-blend-overlay" aria-hidden="true" />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-charcoal via-transparent to-transparent" aria-hidden="true" />
                <span className="glass absolute left-4 top-4 rounded-full border border-aqua/30 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-aqua">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-7">
                <h3 className="font-display text-xl font-bold text-offwhite">{f.name}</h3>
                <dl className="mt-5 flex-1 space-y-3.5">
                  {f.specs.map(([k, v]) => (
                    <div key={k} className="flex items-start justify-between gap-4 border-b border-black/[0.06] pb-3 text-sm">
                      <dt className="text-muted">{k}</dt>
                      <dd className="text-right font-medium text-offwhite/90">{v}</dd>
                    </div>
                  ))}
                </dl>
                <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-aqua/70">
                  Subject to availability
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
